module.exports = {
    subscriptionsErrorCodes: {
        alreadySubscribed: 'SS1',
        planNotFound: 'SS2',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/subscriptions-errorcodes.js